import { Controller } from "@hotwired/stimulus"
import { getCookie, setCookie } from '../lib/cookies';

export default class extends Controller {

  toggle() {
    console.log("Toggling sidebar")
    if (this.element.classList.contains("sidebar-collapsed")) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  collapse() {
    this.element.classList.add("sidebar-collapsed")
    setCookie('crex_sidebar_collapsed', true)
  }

  expand() {
    this.element.classList.remove("sidebar-collapsed")
    setCookie('crex_sidebar_collapsed', false)
  }
}
